export default __webpack_public_path__ + "05209c9c9d8c255a80aab183c97b84ca.svg";